module.exports = __webpack_public_path__ + "img/Skizze6.7c4a72f7.jpg";